import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { AutomotricesService } from '../../../services/creditos/automotrices.service';
import { PlazosService } from "../../../services/plazos.service";
import { CreditosService } from "../../../services/creditos.service";
import { ValidatorService } from '../../../services/tools/validator.service';
import { ConveniosService } from '../../../services/convenios.service';

@Component({
    selector: 'automotriz-simulador',
    templateUrl: './automotriz-simulador.component.html',
    styleUrls: ['./automotriz-simulador.component.scss']
  })
  export class AutomotrizSimuladorComponent implements OnInit {
    //Constants
    private tipoCredito = 2;
    //Cliente form
    public errors:any = {};
    public idCreditos: number = null;
    //UI
    public automotriz : any = { porcentaje_avaluo : 75};
    public automotrizTotals : any = {};
    public cliente : any = {};
    public prestamo : any = {};
    public plazos : any = [];
    public plazoSelected : any = '';
    public catalogoPeriodicidad: any = {};
    //Deducciones
    public facturas : any = { porcentaje : null, valor : null};
    public endosos : any = { porcentaje : null, valor : null};
    public kilometraje : any = { porcentaje : null, valor : null};
    public fisicoInteriores : any = { porcentaje : null, valor : null};
    public fisicoExteriores : any = { porcentaje : null, valor : null};
    public foranidadFactura : any = { porcentaje : null, valor : null};
    public juegoLlaves : any = { porcentaje : null, valor : null};
    //Helpers
    public arrayTen : object = null;
    public arrayTenPosNeg : object = null;
    public arrayTenNegative : object = null;
    //Subscriptions
    private sub: any;
    //Edit mode
    private id : number = null;
    //Selección de convenio
    public convenioDefault = "";
    public convenioSelected:any = {id:null};
    public optConvenios = []

    constructor(
      private helperService: HelpersService,
      private location: Location,
      private automotricesService : AutomotricesService,
      private plazosService: PlazosService,
      private creditosService: CreditosService,
      private activeRoute: ActivatedRoute,
      private router: Router,
      private validatorService : ValidatorService,
      private conveniosService : ConveniosService
    ){
      //Fill the static arrays
      this.arrayTen = [0,1,2,3,4,5,6,7,8,9,10];
      this.arrayTenPosNeg = [-10,-9,-8,-7,-6,-5,-4,-3,-2,-1,0,1,2,3,4,5,6,7,8,9,10];
      this.arrayTenNegative = [0,-1,-2,-3,-4,-5,-6,-7,-8,-9,-10];
    }

    public ngOnInit() {
      this.setDefaultValues();
      this.getPlazos();
      this.getConvenios();
      this.sub = this.activeRoute.params.subscribe(params => {
        if(params['id']){
          //Edit mode
          this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
          this.getCredito(this.id);
        } 
      });
    }

    private setDefaultValues(){
      this.prestamo.calculo = 2;//Calculo crédito simple
      this.prestamo.periodicidad = 2;//Periodicidad Mensual
      this.catalogoPeriodicidad = this.creditosService.getCatalogoPeriodicidad();
    }

    public getConvenios(){
      // let filters = this.getActiveFilters();
  
      this.conveniosService.getAll({tipo:"Prendario"}).subscribe(
        (response)=>
        {
          let respuesta = response.json().content;
          console.log(respuesta);
          if (respuesta.length > 1){
            this.optConvenios = respuesta;
            this.convenioDefault = "Sin convenio";
          }else{
            this.optConvenios = respuesta;
            this.convenioDefault = "Sin convenio";
            this.prestamo.idConvenio = null;
          }
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }
  
    convenioChanged(tipo){
      console.log("Event convenio: ", tipo);
      
      if(tipo.id){
          this.convenioSelected = tipo;
          // this.convenio.tipo_convenio = this.tipoSelected.nombre;
          // console.log("Tipo convenio: ",this.automotriz);
          // this.prestamos.calculo = this.convenioSelected.calculo;
          this.prestamo.periodicidad = this.convenioSelected.periodicidad;
          this.automotriz.idConvenio = this.convenioSelected.id;
          // this.prestamos.convenio = this.convenioSelected.id;
      }else{
        this.setDefaultValues();
      }
    }
    private selectConvenio(tipo){
      this.convenioSelected = this.optConvenios[0];
      // this.convenio.tipo_convenio = this.tipoSelected;
      for (let index = 0; index < this.optConvenios.length; index++) {
        const element = this.optConvenios[index];
        if(element.nombre === tipo){
          this.convenioSelected = this.optConvenios[index];
          // this.convenio.tipo_convenio = tipo;
          break;
        }
        
      }
    }

    private getCredito(idCredito){
      
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.automotricesService.get(idCredito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.automotriz = result.automotriz;
          this.prestamo = result.credito.prestamo;
          this.cliente = result.credito.cliente;
          //Recalcular las deducciones
          this.changePrecioCompra();
          this.selectPlazo(result.credito.prestamo);
          
          
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public save(){
      this.errors = {};
      
      let credito = {
        idCreditos : null,
        automotriz : this.automotriz,
        prestamo : this.prestamo,
        cliente : null
      };

      if(typeof this.cliente.email === 'object'){
        //Cuando se selecciono un usuario con Typeahead, 
        //el modelo cliente.email tiene asociado un objeto con todos los datos del cliente
        let clienteToSave = {
          email : this.cliente.email.email,
          nombre : this.cliente.nombre,
          //Cuando es un update el modelo this.cliente tiene todos los datos del cliente
          //En el caso del create en el modelo this.cliente.email Typeahead pone el JSON completo del Cliente
          id : (this.cliente.id ? this.cliente.id : this.cliente.email.id)
        };
        credito.cliente = clienteToSave;
      }else{
        //Caso cuando el email se ingreso de forma manual
        credito.cliente = this.cliente;
      }

      //El plazo seleccionado esta en el modelo plazoSelected, se debe actualizar el valor en el modelo que se enviará al servicio
      if(this.plazoSelected){
        //Default solo para pruebas
        credito.prestamo.plazo_periodo = this.plazoSelected.periodo;
        credito.prestamo.plazo_medida = this.plazoSelected.medida;
      }

      this.errors = this.automotricesService.validate(credito, this.automotrizTotals.prestamoTotal);
      if (Object.entries(this.errors).length > 0) {
        return false;
      }

      if(this.id){
        //Update credito
        //set idCreditos
        credito.idCreditos = this.id;
        this.update(credito);
      }else{
        //New credito
        this.create(credito);
      }
      
      
    }

    private create(credito){
      this.automotricesService.save(credito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          //Navigate to tabla de amortizacion
          this.router.navigate(['/creditos/tabla-amortizacion/', result.id]);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.showSaveCreditErrors(error.json().content);
          }
        }
      );
    }

    private update(credito){
      this.automotricesService.update(credito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          //Navigate to tabla de amortizacion
          this.router.navigate(['/creditos/tabla-amortizacion/', this.id]);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.showSaveCreditErrors(error.json().content)
          }
        }
      );
    }

    public changePrecioCompra()
    {
      //TODO: Validar que los campos estén llenos
      let newPrice = this.automotriz.precio_compra;
      //Los cálculos dependen que ya se haya definido el precio del libro Azul
      if(!newPrice){
        return false;
      }
      //Aplicar el 25% de descuento
      let prestamoTotal = (newPrice * (this.automotriz.porcentaje_avaluo / 100));
      this.automotrizTotals.porcentajeTotal = prestamoTotal;
      
      //1. Aplicar deducción de Facturas
      if(this.validatorService.numeric(this.automotriz.numero_facturas)){
        this.facturas.porcentaje = this.automotriz.numero_facturas * 5;
        prestamoTotal = prestamoTotal - (prestamoTotal * (this.facturas.porcentaje / 100));
        this.facturas.valor = prestamoTotal;
      }

      //2. Aplicar deducción de Endosos
      if(this.validatorService.numeric(this.automotriz.numero_endosos)){
        this.endosos.porcentaje = this.automotriz.numero_endosos * 3;
        prestamoTotal = prestamoTotal - (prestamoTotal * (this.endosos.porcentaje / 100));
        this.endosos.valor = prestamoTotal;
      }

      //3. Aplicar deducción de Kilomentraje
      if(this.validatorService.numeric(this.automotriz.ajuste_kilometraje)){
        this.kilometraje.porcentaje = this.automotriz.ajuste_kilometraje ;
        //Lo multiplico por -1 para que si el valor seleccionado es negativo haga una deducción  y si es positivo haga una adición
        prestamoTotal = prestamoTotal - (prestamoTotal * (this.kilometraje.porcentaje / 100) * -1);
        this.kilometraje.valor = prestamoTotal;
      }

      //4. Aplicar deducción de Edo físico interior
      if(this.validatorService.numeric(this.automotriz.fisico_interiores)){
        //Lo multiplico por -1 para que si el valor seleccionado es negativo haga una deducción
        this.fisicoInteriores.porcentaje = this.automotriz.fisico_interiores * -2;
        prestamoTotal = prestamoTotal - (prestamoTotal * (this.fisicoInteriores.porcentaje / 100) );
        this.fisicoInteriores.valor = prestamoTotal;
      }

      //5. Aplicar deducción de Edo físico exterior
      if(this.validatorService.numeric(this.automotriz.fisico_exteriores)){
        //Lo multiplico por -1 para que si el valor seleccionado es negativo haga una deducción
        this.fisicoExteriores.porcentaje = this.automotriz.fisico_exteriores * -2;
        prestamoTotal = prestamoTotal - (prestamoTotal * (this.fisicoExteriores.porcentaje / 100));
        this.fisicoExteriores.valor = prestamoTotal;
      }

      //6. Aplicar deducción de Foranidad de la factura
      if(this.validatorService.numeric(this.automotriz.factura_agencia)){
        this.foranidadFactura.porcentaje = this.automotriz.factura_agencia * 2;
        prestamoTotal = prestamoTotal - (prestamoTotal * (this.foranidadFactura.porcentaje / 100));
        this.foranidadFactura.valor = prestamoTotal;
      }

      //6. Aplicar deducción del juego de llaves
      if(this.validatorService.numeric(this.automotriz.juego_llaves)){
        this.juegoLlaves.porcentaje = this.automotriz.juego_llaves * 2;
        prestamoTotal = prestamoTotal - (prestamoTotal * (this.juegoLlaves.porcentaje / 100));
        this.juegoLlaves.valor = prestamoTotal;
      }

      if(this.automotriz.tenencias){
        prestamoTotal = prestamoTotal - this.automotriz.tenencias;
      }

      if(this.automotriz.presupuesto_reparacion){
        prestamoTotal = prestamoTotal - this.automotriz.presupuesto_reparacion;
      }

      this.automotrizTotals.prestamoTotal = prestamoTotal;
      
    }

    public goBack(){
        this.location.back();
    }

    /**
     * Helpers
     */

    private getPlazos(){
      this.plazosService.getAll(this.tipoCredito).subscribe(
        (response)=>
        {
          this.plazos = response.json().content;
        }, error =>
        {  
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }
  
    private setBackendErrors(errors:any[]){
      let temp_errors = [];
      
      Object.keys(errors).forEach(function(key){
        temp_errors[key] = errors[key][0];
      });
  
      this.errors = temp_errors;
    }

    private selectPlazo(prestamo : any){
      let selectedPlazo = null;
      this.plazos.forEach(function(element) {
        
        if(prestamo.plazo_periodo === element.periodo && prestamo.plazo_medida === element.medida){
          selectedPlazo = element;
        }
      });

      if(selectedPlazo){
        this.plazoSelected = selectedPlazo;
      }
    }

    private showSaveCreditErrors(errors){
      let temp_errors = [];
      
      Object.keys(errors).forEach(function(key){
        //temp_errors.push()
  
        //TODO: Agregar el mapeo de todos los posibles errores en el backend
        switch(key){
          case 'cliente.email':
              temp_errors['email'] = errors[key][0];
            break;
        }
      });
  
      this.errors = temp_errors;
    }

}


// WEBPACK FOOTER //
// ./src/app/creditos/automotriz/simulador/automotriz-simulador.component.ts